export const ImageTypeList = [
    { value: "1", label: '图片' },
    { value: "2", label: '插画' },
    { value: "3", label: '漫画' },
    { value: "4", label: '图表' },
    { value: "5", label: '矢量图' }
];

export const ImageOrientationList = [
    {
        value: '-1',
        label: '全部'
    },
    {
        value: '1',
        label: '横图'
    },
    {
        value: '2',
        label: '竖图'
    },
    {
        value: '3',
        label: '方图'
    }
]

export const ImageUsesList = [
    {
        useId: 1000,
        useTitle: '全部可用',
        useDetail: '网络、线下均可使用'
    },
    {
        useId: 2000,
        useTitle: '网络可用',
        useDetail: '微信微博、网页配图、APP等'
    },
    {
        useId: 3000,
        useTitle: '线下可用',
        useDetail: '印刷、书籍、海报、户外广告等'
    },
    {
        useId: 4000,
        useTitle: '其他',
        useDetail: ''
    },
]

export const AicgUseTypeList = [
    {
        value: '1',
        label: '未使用AIGC',
    },
    {
        value: '2',
        label: '全部使用AIGC'
    },
    {
        value: '3',
        label: '部分使用AIGC'
    }
]
export const AigcUseTypeMap = {
    NO_USE: '1',
    ALL_USE: '2',
    PART_USE: '3'
}

export const AigcUseRateList = [
    {
        value: '20',
        label: '20%'
    },
    {
        value: '40',
        label: '40%'
    },
    {
        value: '60',
        label: '60%'
    },
    {
        value: '80',
        label: '80%'
    },
]

export const AigcUseRateFilterList = [
    {
        value: '-1',
        label: '全部'
    },
    {
        value: '20',
        label: '约20%'
    },
    {
        value: '40',
        label: '约40%'
    },
    {
        value: '60',
        label: '约60%'
    },
    {
        value: '80',
        label: '约80%'
    },
    {
        value: '0',
        label: '其他'
    }
]

export const aigcToolsList = [
    {
        value: '-1',
        label: '全部'
    },
    {
        value: '1',
        label: 'Midjourney'
    },
    {
        value: '2',
        label: 'Stable Diffusion'
    },
    {
        value: '100',
        label: '其他'
    }
]

// AI 创造工具
export const AI_TOOL_VALUE_ENUM = {
    MIDJOURNEY: 1,
    STABLE_DIFFUSION: 2,
    OTHER: 100
}